import React from "react";

function SvgIcMapPoi028(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 19a3.408 3.408 0 01-2.535-1.13c.107-.448.476-.839.997-1.1a2.556 2.556 0 003.075 0c.522.261.891.652.998 1.1A3.41 3.41 0 0116 19zm0-6a1.715 1.715 0 11-.002 3.43A1.715 1.715 0 0116 13zm3.998-1H12l.001 8h7.998l-.001-8zm-9.997 10h11.998V10H10.001v12zM24 22a1 1 0 01.999-1l-.001-2.015a.998.998 0 010-1.997v-2.003a.998.998 0 01-.001-1.997l-.001-2.003a.998.998 0 010-1.997V7h-2a1 1 0 11-1.999 0h-2a1 1 0 11-1.999 0h-2.104a1 1 0 01-1.999 0h-1.896A1 1 0 119 7H7v2a1 1 0 010 2v2a1 1 0 010 2v2a1 1 0 110 2v2.015a1 1 0 010 1.997V25h2a1 1 0 111.999 0h1.896a1 1 0 111.999 0h2.104a1 1 0 111.999 0h2a1 1 0 111.999 0H25l-.001-2A.999.999 0 0124 22z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi028;
